import React, { useState } from 'react';
import { translations } from '../translations';

function WaitlistForm({ language = 'en' }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      const response = await fetch('https://api.brevo.com/v3/contacts', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'api-key': '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'
        },
        body: JSON.stringify({
          email: email,
          listIds: [4], // Waitlist ID
          updateEnabled: true
        })
      });

      if (!response.ok) {
        throw new Error('Failed to subscribe');
      }

      // Send welcome email using template
      await fetch('https://api.brevo.com/v3/smtp/email', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'api-key': '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'
        },
        body: JSON.stringify({
          templateId: 1,
          to: [{ email: email }]
        })
      });

      setStatus('success');
      setMessage(translations[language].hero.waitlistSuccess);
      setEmail('');
    } catch (error) {
      setStatus('error');
      setMessage(translations[language].hero.waitlistError);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-md mx-auto">
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={translations[language].hero.waitlistPlaceholder}
          className="flex-1 px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#3498DB] focus:border-transparent transition-shadow bg-white/95 backdrop-blur-sm"
          required
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className={`px-6 py-3 bg-[#3498DB] text-white rounded-lg font-semibold transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg hover:bg-[#2980B9] flex items-center justify-center
            ${status === 'loading' ? 'opacity-75 cursor-not-allowed' : ''}`}
        >
          {status === 'loading' ? (
            <>
              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin mr-2"></div>
              {translations[language].hero.waitlistSubmitting}
            </>
          ) : (
            translations[language].hero.waitlistSubmit
          )}
        </button>
      </div>
      {message && (
        <div className={`mt-3 p-3 rounded-lg text-sm ${
          status === 'success' 
            ? 'bg-green-50 text-green-700 border border-green-100' 
            : 'bg-red-50 text-red-700 border border-red-100'
        }`}>
          {message}
        </div>
      )}
    </form>
  );
}

export default WaitlistForm; 